import axios from 'axios';

import { API_BASE_URL } from '@config';
import * as ActionsDialog from 'app/store/actions';

// SET
export const SET_DASHBOARD = 'SET_DASHBOARD';
export const setDashboard = d => ({
	type: SET_DASHBOARD,
	payload: d
});


// * ////////////// GET ////////////// * //
export const getDashboard = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/dashboard`);
	return request
		.then(response => {
			//dispatch(ActionsDialog.toggleLoading());
			dispatch(setDashboard(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			//dispatch(setError({ ...err.data, type: 'modal' }));
		});
};

